import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import Heritage from "@/pages/Heritage";
import Initiatives from "@/pages/Initiatives";
import Contact from "@/pages/Contact";
import EventsHub from "@/pages/EventsHub";
import FamilyBusinessConclave from "@/pages/FamilyBusinessConclave";
import { Toaster } from "@/components/ui/sonner";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/heritage" element={<Heritage />} />
          <Route path="/initiatives" element={<Initiatives />} />
          <Route path="/events" element={<EventsHub />} />
          <Route path="/events/family-business-conclave" element={<FamilyBusinessConclave />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
